import React, { Component } from 'react';
import { Container } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import * as Cookies from 'es-cookie';
import MyRecords from './MyRecords';
import LeadManagement from './LeadManagement';
import EmployeeCreation from './EmployeeCreation';

/*
 * Queries fed into this component (all resolved by LeadManagementNew.jsx page):
 *
 *  1. globals(institution_id)            → globalBranches, classes, exams, sections, packages …
 *  2. getCallStatusTypes(id: 0)          → id, calling_status
 *  3. getLeadStatusTypes(institute_id)   → id, lead_status_type
 *  4. getLeadTaskStatusDetails(employee_id, institute_id) → lead_status_details  [JSON]
 *  5. getNextLevelUserAndEmployeeDetails(institute_id, branch_id, head_employee_id, is_grouping)
 *                                        → level_id, employee_id, employee_name, next_level_emp,
 *                                          status_details [JSON]
 *  6. getNextLevelTotalUsers(institute_id, branch_id, employee_id)
 *                                        → status_details { status_id status_name status_count }
 *                                          total_users_details { employee_id employee_name
 *                                            lead_details { id lead_status_type details { … } } }
 *
 * Imperative queries inside sub-components (own Apollo client):
 *  7. getUnassignedAndAssignedLeads      → unAssigned_Leads, assigned_Leads   [LeadManagement]
 *  8. getLeadManagementEmployees         → employee_id, employee_name …        [LeadManagement]
 *  9. getFormFieldsData                  → form field details                  [LeadManagement / MyRecords]
 *
 * Mutations inside sub-components:
 * 10. addOrDeleteLeads(params)           → assign / unassign / delete leads    [LeadManagement]
 * 11. addLevelEmployees(params)          → create / update employee levels      [EmployeeCreation]
 */

const VALID_TABS = ['my-task', 'my-team-task', 'lead-management', 'user-management'];

const THEME = {
    bg: 'linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)',
    card: '#ffffff',
    border: '#e2e8f0',
    headerBg: '#f8fafc',
    activeColor: '#6366f1',
    inactiveColor: '#4b5563',
};

class LeadManagementMain extends Component {
    setActiveTab = (tab) => {
        this.props.history.push(`/lead-management/${tab}`);
    };

    buildTabs() {
        const userLevel = Cookies.get('userlevel');
        const isAdmin = userLevel === '1' || userLevel === '2';

        const all = [
            { key: 'my-task',         label: 'My Task',         icon: 'fal fa-clipboard-list', show: true },
            // { key: 'my-team-task',    label: 'My Team Task',    icon: 'fal fa-users',          show: true },
            { key: 'lead-management', label: 'Lead Management', icon: 'fal fa-funnel-dollar',  show: isAdmin },
            { key: 'user-management', label: 'User Management', icon: 'fal fa-user-cog',       show: isAdmin },
        ];
        return all.filter((t) => t.show);
    }

    render() {
        const {
            globals,
            getCallStatusTypes,
            getLeadStatusTypes,
            getMyTasks,
            getNextLevelUserAndEmployeeDetails,
            getNextLevelTotalUsers,
            getMyTeamTasks,
            match,
        } = this.props;

        const tabs = this.buildTabs();
        const tabParam = match && match.params && match.params.tab;
        const validKeys = tabs.map((t) => t.key);
        const activeTab = validKeys.includes(tabParam) ? tabParam : validKeys[0];

        return (
            <div style={{ background: THEME.bg, minHeight: '100vh', padding: '24px 28px' }}>
                <Container fluid className="px-0">
                    <div
                        style={{
                            background: THEME.card,
                            borderRadius: 16,
                            boxShadow: '0 4px 24px rgba(0,0,0,0.05)',
                            overflow: 'hidden',
                            border: `1px solid ${THEME.border}`,
                        }}
                    >
                        {/* ── Tab header ── */}
                        <div
                            style={{
                                background: THEME.headerBg,
                                borderBottom: `1.5px solid ${THEME.border}`,
                                padding: '12px 24px 0 24px',
                            }}
                        >
                            <ul className="nav nav-tabs" style={{ borderBottom: 'none', gap: 8 }}>
                                {tabs.map((tab) => {
                                    const isActive = activeTab === tab.key;
                                    return (
                                        <li className="nav-item" key={tab.key}>
                                            <a
                                                className={`nav-link ${isActive ? 'active' : ''}`}
                                                href="#"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    this.setActiveTab(tab.key);
                                                }}
                                                style={{
                                                    cursor: 'pointer',
                                                    fontWeight: 700,
                                                    fontSize: 14,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 8,
                                                    padding: '12px 20px',
                                                    color: isActive ? THEME.activeColor : THEME.inactiveColor,
                                                    background: isActive ? '#fff' : 'transparent',
                                                    borderColor: isActive
                                                        ? `${THEME.border} ${THEME.border} #fff`
                                                        : 'transparent',
                                                    borderWidth: '1.5px',
                                                    borderBottomWidth: isActive ? '2px' : '1.5px',
                                                    borderRadius: '10px 10px 0 0',
                                                    transition: 'all 0.15s ease',
                                                    marginBottom: '-1.5px',
                                                    textDecoration: 'none',
                                                }}
                                            >
                                                <i className={tab.icon} />
                                                {tab.label}
                                            </a>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>

                        {/* ── Tab content ── */}
                        <div style={{ padding: '28px' }}>
                            {activeTab === 'my-task' && (
                                <MyRecords
                                    getMyTasks={getMyTasks}
                                    getCallStatusTypes={getCallStatusTypes}
                                    getLeadStatusTypes={getLeadStatusTypes}
                                />
                            )}

                            {activeTab === 'lead-management' && (
                                <LeadManagement globals={globals} />
                            )}

                            {activeTab === 'user-management' && (
                                <EmployeeCreation globals={globals} />
                            )}
                        </div>
                    </div>
                </Container>
            </div>
        );
    }
}

export default withRouter(LeadManagementMain);
